import { InvoiceDocumentType } from '../../../enums/invoiceDocumentType'
import { QuoteListFilter } from '../../../enums/quoteListFilter'
import { QuoteStatus } from '../../../enums/quoteStatus'
import { Quote } from '../../../types/quotes/quote'
import { QuoteRowStatus } from '../types/quoteRowStatus'

export const getQuoteRowStatus = (
  documentType: Quote['documentType'],
  status: QuoteStatus | undefined,
): QuoteRowStatus => {
  if (documentType === InvoiceDocumentType.QuoteDraft) {
    return QuoteListFilter.Draft
  }

  switch (status) {
    case QuoteStatus.Accepted:
      return QuoteListFilter.Accepted
    case QuoteStatus.Rejected:
      return QuoteListFilter.Rejected
    case QuoteStatus.Invoiced:
      return QuoteListFilter.Invoiced
    // `created` / `open` / `sent` / `unsent` (and any unexpected status) are shown as pending
    default:
      return QuoteListFilter.Pending
  }
}
